import translations from './translations'

translations.add('es', {
    header: '¿Desea donar a una organización benéfica?',
    donate: 'Donar',
    thanks: '¡Gracias por su donación!'
})
